import { grey } from '@mui/material/colors';
import MenuItem from '@mui/material/MenuItem';
import Select, { selectClasses } from '@mui/material/Select';
import { styled } from '@mui/material/styles';

export const OptionsDropdown = styled(Select)(() => ({
  height: '30px',
  marginTop: 'auto',
  marginBottom: 'auto',
  marginLeft: '5px',
  marginRight: '5px',
  fontSize: 12,
  outline: 'none',
  [`& .${selectClasses.select}`]: {
    border: `1px solid ${grey[100]}`,
    borderRadius: 4,
    padding: '4px 8px',
    '&:hover': {
      borderColor: grey[300],
      outline: 0,
    },
    '&:focus': {
      borderColor: grey[400],
    },
  },
}));

export const OptionMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: 12,
  minHeight: 'auto',
  padding: theme.spacing(0.5, 1),
}));
